<template>
    <div class="dashboard">dashboard</div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {

            }
        }
    }
</script>

<style lang="less">
.dashboard {
	color: @primary-color;
}
</style>